<template>
  <section class="pt-7 px-10  roboto homecontainer mx-auto calcheight">
    <h2
      class="text-left font-black text-l mb-7 text-30px text-skin-secondary mb-20"
    >
      Facturación
    </h2>
    <p class="text-skin-secondary mb-40px text-xm">
      Encuentra tus comprobantes de pago aquí después de haber realizado tu
      compra
    </p>

    <div
      class="grid gap-40 grid-cols-1fr 1xl:grid-cols-2fr justify-items-center"
    >
      <DownloadInvoice
        v-for="(invoice, index) in GET_INVOICES"
        :key="index"
        :amount="invoice.total"
        :pedido="invoice.transaction_id"
        :date="invoice.created_at"
      />
    </div>
  </section>
</template>

<script>
import DownloadInvoice from "../components/DownloadInvoice.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    DownloadInvoice,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("invoices", ["GET_INVOICES"]),
    ...mapGetters("userCourses", ["GET_USERCOURSES"]),
  },
  mounted() {
    this.$store.dispatch("invoices/get_invoices", {
      perPage: 4,
      currentPage: 1,
    });
  },
};
</script>
